/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getPropertyInfo = /* GraphQL */ `query GetPropertyInfo($id: ID!) {
  getPropertyInfo(id: $id) {
    id
    brandName
    gstNumber
    invoiceTemplate
    packageFeatureEnabled
    foodTypeFeatureEnabled
    groupRoomsByBlockFeatureEnabled
    singleOccupancyFeatureEnabled
    refTariffGstInclFeatureEnabled
    confirmPayModeFeatureEnabled
    posInvoiceFeatureEnabled
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPropertyInfoQueryVariables,
  APITypes.GetPropertyInfoQuery
>;
export const listPropertyInfos = /* GraphQL */ `query ListPropertyInfos(
  $filter: ModelPropertyInfoFilterInput
  $limit: Int
  $nextToken: String
) {
  listPropertyInfos(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      brandName
      gstNumber
      invoiceTemplate
      packageFeatureEnabled
      foodTypeFeatureEnabled
      groupRoomsByBlockFeatureEnabled
      singleOccupancyFeatureEnabled
      refTariffGstInclFeatureEnabled
      confirmPayModeFeatureEnabled
      posInvoiceFeatureEnabled
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPropertyInfosQueryVariables,
  APITypes.ListPropertyInfosQuery
>;
